import {ProductDataStore} from "../../stores/productDataStore";
import {AppStateService} from "../../services/appStateService";

export class TypeService {
    private productDataStore: ProductDataStore;
    private appStateService: AppStateService;

    constructor() {
        this.productDataStore = new ProductDataStore();
        this.appStateService = new AppStateService();
    }
}
